import React from 'react'
import PropTypes from 'prop-types'
import {useStyleConfig, TableContainer, Table, Tr, Td, Tbody} from '@chakra-ui/react'
import {CheckIcon} from '../../../icons'

const AccordionList = ({lists}) => {
    const styles = useStyleConfig('Accordion')

    if (!Array.isArray(lists) || lists.length === 0) return

    return (
        <TableContainer>
            <Table {...styles.accordionList}>
                <Tbody>
                    {lists.map((list, index) => (
                        <Tr key={index} {...styles.accordionPanelElement}>
                            <Td {...styles.accordionPanelTextList}>
                                {list?.value_name && list.value_name}
                            </Td>
                            <Td {...styles.accordionPanelTextList}>
                                {list?.has_check ? (
                                    <CheckIcon data-testid="check-icon" {...styles.checkIconBox} />
                                ) : (
                                    <>{list?.value && list.value}</>
                                )}
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    )
}

AccordionList.propTypes = {
    lists: PropTypes.arrayOf(
        PropTypes.shape({
            value_name: PropTypes.string,
            has_check: PropTypes.bool,
            value: PropTypes.string,
        }),
    ),
}

export default AccordionList
